import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Best from '../components/Best';

function BestPage() {
  return (
    <>
      <Header />
      <div className="pt-16 md:pt-20">
        <Best />
      </div>
      <Footer />
    </>
  );
}

export default BestPage;
